module.exports = __webpack_public_path__ + "img/gratitude-journal_B095L66YKH.87f5b363.jpg";